import { isFuture, isPast } from 'date-fns'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Badge } from '@ui/components/Badge/Badge'

import { CampaignStatusEnum } from '@model/CampaignStatusEnum'
import { DocumentStatus } from '@model/DocumentStatus'
import { NameDto } from '@model/NameDto'

interface CampaignStatusProps {
  status: NameDto<CampaignStatusEnum> & { type?: DocumentStatus }
  from: string
  to: string
}

export const CampaignResultsStatusBadge: React.FC<CampaignStatusProps> = (props) => {
  const { t } = useTranslation()
  const { status, from, to } = props
  const { id, type = DocumentStatus.None } = status
  const statusType = id | type

  const isCampaignEnded = isPast(new Date(to)) || statusType === CampaignStatusEnum.Disabled
  const isCampaignActive =
    isPast(new Date(from)) && isFuture(new Date(to)) && statusType === CampaignStatusEnum.Enabled

  if (isCampaignEnded) {
    return (
      <Badge type='black' contrast='low' size='sm'>
        {t('Ended')}
      </Badge>
    )
  }

  if (isCampaignActive) {
    return (
      <Badge type='green' contrast='low' size='sm'>
        {t('Active')}
      </Badge>
    )
  }

  return (
    <Badge type='danger' contrast='low' size='sm'>
      {t('Paused')}
    </Badge>
  )
}
